"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePlanningItemDeliveryAddressChange = void 0;
const iaddress_1 = require("./iaddress");
function parsePlanningItemDeliveryAddressChange(data) {
    if (data.address !== null && typeof data.address === 'object')
        data.address = (0, iaddress_1.parseIAddress)(data.address);
    return data;
}
exports.parsePlanningItemDeliveryAddressChange = parsePlanningItemDeliveryAddressChange;
